export default function WhoIsThisProductFor() {
    return {
        title: 'Who is this Product for?',
        paragraphs: [
            '<div>Review your book of business for opportunities:<div>',
            '<ul class="mt-2"><li class="pl-2">Late career (50+) and retired clients</li><li class="pl-2">On-track and at-risk clients in Goals Planning System</li></ul>',
            '<div>Conversation Starters:</div>',
            '<ul class="mt-2 mb-0"><li class="pl-2">If you need extended care due to a situation such as Alzheimer’s, what are the assets that will be used to pay for care?</li><li class="pl-2">If you need extended care, where would you prefer that occur? At home or an assisted living community? Is your family aware of your desires?</li><li class="pl-2">If you own a Health Savings Account (HSA), are you aware that you can use HSA dollars to help pay LTC premiums?</li></ul>',
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/traditional-long-term-care/WhoIsThisProductData.js